import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {DocumentAttachment} from '@npck/af-frontend-api';
import {Spinner} from '@npck/libs/commons';
import {ContactForm} from '../contact-details-step.component';

@Component({
    selector: 'af-contact-details-expansion-panel',
    templateUrl: './contact-details-expansion-panel.component.html',
    standalone: false,
})
export class ContactDetailsExpansionPanelComponent {
    @Input() contactForm: FormGroup<ContactForm>;
    @Input() showDeleteButton: boolean;
    @Input() showAddContactButton: boolean;
    @Input() isAddContactButtonDisabled: boolean;
    @Input() index: number;
    @Input() viewIndex: number;
    @Input() msisdnPredefinedValue: string;
    @Input() msisdnReadOnly = false;
    @Input() hidePanel = false;
    @Input() existingAttachments: DocumentAttachment[];
    @Output() deleteContactListener = new EventEmitter<number>();
    @Output() addNewContactListener = new EventEmitter<void>();
    @Output() addLinkListener = new EventEmitter<void>();
    @Output() removeLinkListener = new EventEmitter<number>();

    Spinner = Spinner;

    private _expanded = false;
    private wasExpanded = false;

    get expanded(): boolean {
        return this._expanded;
    }

    @Input()
    set expanded(value: boolean) {
        if (value) {
            this._expanded = true;
            this.wasExpanded = true;
        } else {
            if (!this.wasExpanded) {
                this._expanded = false;
            }
        }
    }
}
